import locales from 'shared/constants/locales.js';

// O NOME DO IDIOMA EM PORTUGUÊS (08/10/2026).
//
// `locales.js` guarda os nomes em inglês ("Portuguese (Brazil)"), e a
// Central de Ajuda mostrava isso como estava. O navegador sabe dizer o nome
// em português (`Intl.DisplayNames`); o mapa fica só de reserva para código
// que ele não reconheça.
let nomes = null;
try {
  nomes = new Intl.DisplayNames(['pt-BR'], { type: 'language' });
} catch {
  nomes = null;
}

const comMaiuscula = texto => texto.charAt(0).toUpperCase() + texto.slice(1);

export const nomeDoIdioma = codigo => {
  if (!codigo) return '';
  try {
    const nome = nomes?.of(String(codigo).replace('_', '-'));
    if (nome && nome !== codigo) return comMaiuscula(nome);
  } catch {
    // código que o Intl não aceita: cai no mapa
  }
  return locales[codigo] || codigo;
};

export default nomeDoIdioma;
